// import { getAccessToken } from "../spotifyAPI";

import { useState, useEffect } from "react";

// const clientId = "a7ec7b2d86c448a480bf3b1066b5e2f3";

function SearchBar() {
    return (
        <form >
            <input class="firstBubble" id="searcher" type="text" placeholder="Search titles, genres, or users..."/>
            <button class="firstBubble dropdown">Genre</button>
            <button class="firstBubble dropdown">Recommender</button>
            <button class="firstBubble dropdown">Media</button>
        </form>
    );
}

// function Recommendation({SongID}){
//     let accessToken = localStorage.getItem('access_token');

//     const response = fetch('https://api.spotify.com/tracks/' + {SongID}, {
//         headers: {
//         Authorization: 'Bearer ' + accessToken
//         }
//     });

//     const data = response.json();

//     return (
//         <p>{data.name}</p>
//     );
// }

// const SongID = "1Ist6PR2BZR3n2z2Y5R6S1"

// async function APICall(code){
//     const accessToken = await getAccessToken(clientId, code);

//     console.log(accessToken);

//     const response = await fetch("https://api.spotify.com/v1/me", {
//         method: "GET", headers: { Authorization: `Bearer ${accessToken}` }
//     });

//     const data = await response.json();

//     console.log(data);
// }

function Rec() {
    const [loading, setLoading] = useState(false);
    const [recData, setRecData] = useState(null);
    const accessToken = localStorage.getItem("accessToken");

    const fetchRec = async () => {
        setLoading(true);
        try{
            const response = await fetch("https://api.spotify.com/v1/tracks/1Ist6PR2BZR3n2z2Y5R6S1", {
                method: "GET", headers: { Authorization: `Bearer ${accessToken}` }
            });

            const data = await response.json();
            setRecData(data);
        }
        finally {
            // console.log(accessToken);
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchRec();
    }, []);

    if (loading) {
        return <div> Loading </div>; // Show loading while waiting for API call
    }
    if(recData){
        return (
            <div className="songRec">
                <img src={recData.album.images[0].url} className="recImg"/>
                <div className="titleAuthor">
                    <div><b>{recData.name}</b></div>
                    <div>{recData.artists[0].name}</div>
                </div>
            </div>
        );
    }
    return <div> I'm Tweaking </div>;
}

function Recommendations() {
    // const recs = [];
    // Recdata.forEach((rec) => {
    //     recs.push(
    //         <Recommendation SongID={rec.spotifyID} />
    //     )
    // });

    return (
        <div id="recs">
            <h2>Your Recommendations</h2>
            <SearchBar/>
            <h5>Showing 1 result(s)</h5>

            <Rec/>

            {/* <button onClick = {() => APICall(code)}>
                Press to Call Spotify API
            </button> */}

            {/* <tbody>{recs}</tbody> */}
        </div>
    );
}

export default Recommendations;